// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"71":"market-modal","331":"market","784":"showcase"}[chunkId] || chunkId) + "-legacy." + {"71":"e5cec981","231":"dca89297","331":"591be666","784":"a4d47b5f"}[chunkId] + ".js";
};